<template>
  <div id="app">
    <div id="nav">
      <!-- Main container -->
      <nav class="level is-mobile">
        <!-- Left side -->
        <div class="level-left">
          <div class="level-item">
            <router-link to="/" class="menu">
              <span class="icon">
                <i class="fas fa-lg fa-home"></i>
              </span>
            </router-link>
            <router-link to="/chart" class="menu">
              <span class="icon">
                <i class="fas fa-lg fa-chart-line"></i>
              </span>
            </router-link>
            <router-link to="/rules" class="menu">
              <span class="icon">
                <i class="fas fa-lg fa-bolt"></i>
              </span>
            </router-link>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button" @click="logout" >
              <span class="icon">
                <i class="fas fa-sign-out-alt"></i>
              </span>
              <span>Déconnecter</span>
            </a>
          </div>
        </div>
      </nav>
    </div>
    <section class="section">
      <div class="container">
          <router-view/>
      </div>
    </section> 
    <notifications group="global" position="bottom center" />
  </div>
</template>

<script>
import router from './router'
import 'bulma/css/bulma.css'

export default {
  created() {
    // Préchargement
    this.$store.dispatch('lireUnites')
    .then(() => this.$store.dispatch('lireInterfaces'))
  },
  methods: {
    logout() {
        this.$store.dispatch('deconnecter')
        router.push('login')
    }
  }
}
</script>

<style>
html, body {
  margin:0;
  padding:0;
  background: url(assets/fond.jpg) no-repeat center fixed;
  background-size: cover;
}

#nav {
  padding: 10px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  margin: 0;
  z-index: 1;
  background-color: hsla(0,0%,100%,.7);
  box-shadow: 0 0 10px #777;
}

#nav a.router-link-exact-active {
  color: #3273dc;
}

.section {
  padding: 0px;
  padding-top: 56px;
}

.card {
  box-shadow: 0 0 10px #777;
  vertical-align: top;
  margin: 10px;
}

.card-content {
  width: 100%;
}

.menu {
  margin-right: 10px;
  color: #363636;
}
.menu:hover {
  color: #3273dc;
}

/* Boite de dialgue */
.modal .box {
  margin: 10px;
}

@media (max-width: 640px) {
  .card-content {
    padding: 5px;
  }
}

</style>
